import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const testimonials = [{
  name: 'Giulia M.',
  role: 'Docente ITS',
  city: 'Milano',
  tag: 'Weekend recuperati',
  text: 'Ho recuperato i miei weekend. In 5 minuti preparo lezioni di domotica avanzata che prima mi richiedevano intere serate. Gli studenti finalmente lavorano su schemi reali e tornano a casa con competenze concrete.'
}, {
  name: 'Francesca R.',
  role: 'Insegnante Istituto Tecnico',
  city: 'Napoli',
  tag: 'Pianificazione salvata',
  text: 'Dopo 10 anni di insegnamento tecnico, finalmente ho trovato un sistema che funziona davvero. La pianificazione da 200 ore mi ha salvato il semestre. Il Tomo 1 e 2 sono perfetti per partire dalle basi.'
}, {
  name: 'Maria B.',
  role: 'Coordinatrice Tecnica',
  city: 'Roma',
  tag: 'Valutazioni EQF',
  text: 'Le verifiche EQF sono allineate agli standard europei e posso giustificare ogni valutazione in modo oggettivo davanti alla direzione scolastica. Le rubriche del Tomo 6 sono di una chiarezza disarmante.'
}, {
  name: 'Elena C.',
  role: 'Docente Formazione Professionale',
  city: 'Torino',
  tag: 'Lezioni in 2 minuti',
  text: "I laboratori pronti sono una vera salvezza nelle settimane più cariche. Apro il Tomo 4, scelgo l'attività e in 2 minuti sono pronto per l'aula. KNX e ETS 6 finalmente spiegati come si deve."
}, {
  name: 'Marco T.',
  role: 'System Integrator',
  city: 'Bologna',
  tag: 'Autorità tecnica',
  text: 'La sezione Elite mi ha permesso di presentare un progetto di Building Automation industriale con una sicurezza tecnica che non avevo mai avuto prima. Il Digital Twin e i casi studio europei valgono da soli il prezzo.'
}, {
  name: 'Chiara E.',
  role: 'Tecnico Installatore',
  city: 'Palermo',
  tag: 'Sicurezza integrata',
  text: 'Il Tomo 5 sulla sicurezza è eccezionale. Finalmente capisco come integrare TVCC e antintrusione in un unico ecosistema conforme alla normativa EN 50131. Il calcolo DORI spiegato in modo cristallino.'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4" data-id="element-299">
      <div className="max-w-6xl mx-auto" data-id="element-300">
        <p className="text-center text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-301">
          +500 Recensioni Verificate
        </p>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-3 text-brand-cream" data-id="element-302">
          Cosa dicono i docenti e tecnici di tutta Italia
        </motion.h2>
        <div className="flex items-center justify-center gap-2 mb-8" data-id="element-303">
          <div className="flex text-brand-gold" data-id="element-304">
            {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-305" />)}
          </div>
          <p className="text-center text-gray-400 text-sm" data-id="element-306">
            4.9/5 (+500 recensioni)
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4" data-id="element-307">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-brand-card border border-white/5 p-6 rounded-2xl flex flex-col" data-id="element-308">
              <div className="flex items-center justify-between mb-3" data-id="element-309">
                <div className="flex text-brand-gold" data-id="element-310">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-311" />)}
                </div>
                <div className="flex items-center gap-1 text-[10px] font-bold text-green-400 uppercase" data-id="element-312">
                  <ShieldCheckIcon className="w-3 h-3" data-id="element-313" />
                  Verificato
                </div>
              </div>
              <p className="text-gray-300 font-medium italic mb-5 text-sm sm:text-base leading-relaxed" data-id="element-314">
                "{t.text}"
              </p>
              <div className="border-t border-white/10 pt-3 mt-auto flex items-center justify-between gap-3" data-id="element-315">
                <div data-id="element-316">
                  <div className="font-bold text-brand-cream text-sm" data-id="element-317">
                    {t.name}
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-318">
                    {t.role} — {t.city}
                  </div>
                </div>
                <div className="bg-brand-orange/10 border border-brand-orange/30 text-brand-orange text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wide text-right" data-id="element-319">
                  {t.tag}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center" data-id="element-320">
          <div className="inline-flex items-center gap-3 bg-brand-card border border-brand-gold/30 rounded-full px-5 py-2 mb-4" data-id="element-321">
            <span className="font-bold text-brand-cream text-sm" data-id="element-322">
              +300 docenti italiani hanno scelto il Sistema
            </span>
          </div>
          <CTAButton className="max-w-sm mx-auto" data-id="element-323">
            UNISCITI A +300 DOCENTI — ACCEDI ORA
          </CTAButton>
        </div>
      </div>
    </section>;
}